const LOCALE_BY_LANG = {
  fr: "fr-FR",
  en: "en-US",
};

function resolveLocale(language) {
  return LOCALE_BY_LANG[language] || LOCALE_BY_LANG.fr;
}

function parseDate(value) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Date only — e.g. 27/05/2026 (FR) or 5/27/2026 (EN) */
export function formatDateOnly(value, language = "fr") {
  const d = parseDate(value);
  if (!d) return "";

  return new Intl.DateTimeFormat(resolveLocale(language), {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  }).format(d);
}

/** Date and time — e.g. 27/05/2026 16:30:38 (FR) or 5/27/2026, 4:30:38 PM (EN) */
export function formatDateTime(value, language = "fr") {
  const d = parseDate(value);
  if (!d) return "";

  return new Intl.DateTimeFormat(resolveLocale(language), {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: language === "en",
  }).format(d);
}
